export const getPropsToLabel = () => {
  return {
    style: {
      position: 'absolute',
      right: '-25px',
      top: '-3px',
    },
  };
};

export const getPropsToLabelColaboradores = () => {
  return {
    style: {
      position: 'absolute',
      right: '-25px',
      top: '-3px',
    },
  };
};
